"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReportedContent = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _Trash = _interopRequireDefault(require("@insided/shared/icons/Trash"));

var _Warning = _interopRequireDefault(require("@insided/shared/icons/Warning"));

var _SolvedQuestion = _interopRequireDefault(require("@insided/destination/icons/SolvedQuestion"));

var _Shield = _interopRequireDefault(require("@insided/destination/icons/Shield"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _GroupMemberItem = require("./../../GroupMemberItem");

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Report = function Report(props) {
  return (0, _preact.h)("div", {
    key: props.index,
    className: "group-report"
  }, (0, _preact.h)("div", {
    className: "group-report__main"
  }, (0, _preact.h)(_GroupMemberItem.GroupMember, {
    member: props.report.user,
    disablePopup: true,
    isModeration: true
  })), (0, _preact.h)("div", {
    className: "group-report__actions"
  }, (0, _preact.h)(_Button.default, {
    className: "group-report__delete-btn",
    onClick: props.onDelete
  }, (0, _preact.h)(_Trash.default, {
    height: 20,
    width: 20
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.trash"
  })), (0, _preact.h)(_Button.default, {
    className: "group-report__mark-as-spam-btn",
    onClick: props.onMarkAsSpam
  }, (0, _preact.h)(_Warning.default, {
    height: 20,
    width: 20
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.mark.as.spam"
  })), (0, _preact.h)(_Button.default, {
    className: "group-report__resolve-btn",
    onClick: props.onResolve
  }, (0, _preact.h)(_SolvedQuestion.default, {
    height: 20,
    width: 20,
    fill: "#24C25E"
  }), (0, _preact.h)(_phrase.default, {
    p: "groups.resolve"
  }))));
};

var ReportedContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ReportedContent, _Component);

  var _super = _createSuper(ReportedContent);

  function ReportedContent() {
    (0, _classCallCheck2.default)(this, ReportedContent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ReportedContent, [{
    key: "render",
    value: function render() {
      var reports = this.props.reports;
      return (0, _preact.h)("div", {
        className: "group-moderation__reported-content"
      }, reports.length ? reports.map(function (report, index) {
        return (0, _preact.h)(Report, {
          key: index,
          index: index,
          report: report
        });
      }) : (0, _preact.h)("div", {
        className: "group-moderation__pending-requests__empty"
      }, (0, _preact.h)(_Shield.default, {
        height: 40,
        width: 40,
        className: "group-moderation__pending-requests__empty__icon"
      }), (0, _preact.h)("div", {
        className: "group-moderation__pending-requests__empty__title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.all.good"
      })), (0, _preact.h)("div", {
        className: "group-moderation__pending-requests__empty__description"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.all.good.reports.description"
      }))));
    }
  }]);
  return ReportedContent;
}(_preact.Component);

exports.ReportedContent = ReportedContent;
var _default = ReportedContent;
exports.default = _default;